import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import { FormProvider } from 'react-hook-form';
import { Icon, PageTitle, RequiredFieldsNotice } from '@fasstech/middle-design-system';
import useSouscriptionCompanyForm from './hooks/useSouscriptionCompanyForm';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer';
import SouscriptionCompanyDecisionMakerContact from './components/SouscriptionCompanyDecisionMakerContact';
import { SouscriptionCompanyHRContact } from './components/SouscriptionCompanyHRContact';

const SouscriptionCompanyForm = ({
  phoneIndicatives,
  getMiddleText,
  getMiddleBoolean,
  getSouscriptionCompany
}) => {
  const { form, $onClickPrev, onSubmit } = useSouscriptionCompanyForm({
    getSouscriptionCompany
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <PageLayout
          withFormLayout={false}
          className={'flex flex-col items-center w-full gap-y-6'}
        >
          <div className={'flex flex-col items-center gap-6'}>
            <Icon name={'circleHome'} size={70} />
            <PageTitle>
              {getMiddleText('ENTREPRISE_CONTACT_VIEW_TITLE')}
            </PageTitle>
            <RequiredFieldsNotice/>

            <SouscriptionCompanyDecisionMakerContact
              isDisplayed={getMiddleBoolean(
                'ENTREPRISE_CONTACT_DECIDEUR_EST_NECESSAIRE'
              )}
              getMiddleText={getMiddleText}
              getMiddleBoolean={getMiddleBoolean}
              phoneIndicatives={phoneIndicatives}
            />

            <SouscriptionCompanyHRContact
              isDisplayed={getMiddleBoolean(
                'ENTREPRISE_CONTACT_RH_EST_NECESSAIRE'
              )}
              phoneIndicatives={phoneIndicatives}
              getMiddleText={getMiddleText}
              getMiddleBoolean={getMiddleBoolean}
            />
          </div>
        </PageLayout>
        <ButtonContainer
          $onPreviousButtonClick={$onClickPrev}
          nextButtonLabel={getMiddleText(
            'GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL'
          )}
          displayResumeButton
          getMiddleText={getMiddleText}
        />
      </form>
    </FormProvider>
  );
};

export default withMiddleFeatures(SouscriptionCompanyForm);
